import React, { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import {
  Box,
  CircularProgress,
  Grid,
  InputAdornment,
  makeStyles,
  MenuItem,
  TextField,
} from "@material-ui/core";
import { IoIosCalendar } from "react-icons/io";
import { FormikHelpers, useFormik } from "formik";
import * as Yup from "yup";
import moment from "moment";
import GeneralSettingService from "../../../../../services/GeneralSettingService";
import { InputDate } from "../../../../../components/input-date/InputDate";
import { InputButton } from "../../../../../components/input-button/InputButton";
import Alert from "@material-ui/lab/Alert";
import { InputField } from "../../../../../components/input-field/InputField";
import { Business } from "@material-ui/icons";
import ICIPAdminService from "../../../../../services/ICIPAdminService";

interface generalSettingsProps {
  settings: {};
}

const useStyles = makeStyles((theme) => ({}));

export const GeneralSettings = (props: generalSettingsProps) => {
  const { settings } = props;
  const classes = useStyles(props);
  const [error, setError] = useState(false);
  const [succeed, setSucceed] = useState(false);
  const [businesses, setBusinesses] = useState([]);
  const [businessesBranches, setBusinessesBranches] = useState([]);
  const [selectedBusinessId, setSelectedBusinessId] = useState(
    settings["business_partner"] ? settings["business_partner"]["id"] : null
  );
  const [branches, setBranches] = useState([]);
  const [adminUsers, setAdminUsers] = useState([]);
  const intl = useIntl();
  const { formatMessage } = useIntl();

  // Formik
  const formik = useFormik({
    initialValues: {
      renew_raffle_participant: settings["renew_raffle_participant"],
      tombola_ended_at: settings["tombola_ended_at"],
      package_validity_limit: settings["package_validity_limit"],
      //partner_business_id: settings["business_partner"] ? settings["business_partner"]["id"] : null,
      business_branch_id: settings["business_branch"]
        ? settings["business_branch"]["id"]
        : null,
      first_user: settings["first_user"],
      second_user: settings["second_user"],
      third_user: settings["third_user"],
    },
    validationSchema: Yup.object().shape({
      renew_raffle_participant: Yup.string().required(
        intl.formatMessage({ id: "error.renewParticipantIsRequired" })
      ),
      tombola_ended_at: Yup.string().required(
        intl.formatMessage({ id: "error.tombolaEndedDateError" })
      ),
      package_validity_limit: Yup.string().required(
        intl.formatMessage({ id: "error.packageValidityLimitIsRequired" })
      ),
    }),
    onSubmit: async (values, { setSubmitting }: FormikHelpers<any>) => {
      setError(false);
      try {
        let data = formik.values;
        data["partner_business_id"] = selectedBusinessId;
        console.log(data);
        const result = await GeneralSettingService.setGeneralSettings(data);
        if (result.isSuccess && result.data.code === 100) {
          setSucceed(true);
          setTimeout(() => {
            setSucceed(false);
          }, 2000);
        } else {
          setError(true);
        }
      } catch (error) {
        setError(true);
      }
      setSubmitting(false);
    },
  });

  // Events handlers
  const handleDateChange = (name: string, dateString: string) => {
    formik.setValues({ ...formik.values, [name]: dateString });
  };

  const handleBusinessChange = (BusinessId: string) => {
    let tabBranches = [];
    if (BusinessId != "") {
      let id = parseInt(BusinessId);
      tabBranches = businessesBranches[id];

      setSelectedBusinessId(id);
    }
    setBranches(tabBranches);
  };

  useEffect(() => {
    fetchBusinesses();
    fetchAdminUsers();
  }, []);

  const fetchBusinesses = () => {
    GeneralSettingService.getAllbusinesses().then((response) => {
      if (response.isSuccess) {
        switch (response.data.code) {
          case 100:
            const businessesResult = JSON.parse(
              JSON.stringify(response.data.data)
            );

            let tabBranches = [];
            for (let i = 0; i < businessesResult.length; i++) {
              tabBranches[businessesResult[i]["id"]] =
                businessesResult[i]["business_branches"];

              if (
                settings["business_partner"] != null &&
                settings["business_partner"]["id"] == businessesResult[i]["id"]
              ) {
                setBranches(businessesResult[i]["business_branches"]);
              }
            }
            setBusinesses(businessesResult);
            setBusinessesBranches(tabBranches);
            break;
          case 101:
            setError(true);
            break;
        }
      } else {
        setError(true);
      }
    });
  };

  const fetchAdminUsers = () => {
    ICIPAdminService.getAdminUsers().then((response) => {
      if (response.isSuccess) {
        switch (response.data.code) {
          case 100:
            const adminUsersResult = JSON.parse(
              JSON.stringify(response.data.data)
            );
            setAdminUsers(adminUsersResult);
            break;
          case 101:
            setError(true);
            break;
        }
      } else {
        setError(true);
      }
    });
  };

  return (
    <Box component="div" className="settingWrapper">
      <form noValidate autoComplete="off" onSubmit={formik.handleSubmit}>
        <Grid container>
          <Grid item xs={6} sm={6} lg={6}>
            <Box mb={12} component="div" className="settingWrapperInner">
              <Grid item xs={12} sm={6} lg={6}>
                <TextField
                  select
                  variant="outlined"
                  size="small"
                  value={formik.values.renew_raffle_participant}
                  label={formatMessage({ id: "sharedScreen.renewLosers" })}
                  fullWidth
                  name="renew_raffle_participant"
                  onChange={formik.handleChange}
                  error={
                    formik.touched.renew_raffle_participant &&
                    Boolean(formik.errors.renew_raffle_participant)
                  }
                  helperText={
                    formik.touched.renew_raffle_participant &&
                    formik.errors.renew_raffle_participant
                  }
                >
                  <MenuItem value={0}> NO </MenuItem>
                  <MenuItem value={1}> YES </MenuItem>
                </TextField>
              </Grid>
              <br />
              <Grid item xs={12} sm={6} lg={6}>
                <InputDate
                  minDate={moment().format("YYYY-MM-DD HH:mm:ss")}
                  onDateChange={(name, date) => handleDateChange(name, date)}
                  inputProps={{
                    disabled: formik.isSubmitting,
                    fullWidth: true,
                    id: "tombola_ended_at",
                    name: "tombola_ended_at",
                    label: intl.formatMessage({
                      id: "sharedScreen.raffleDrawDate",
                    }),
                    placeholder: intl.formatMessage({
                      id: "sharedScreen.raffleDrawDate",
                    }),
                    endAdornment: (
                      <InputAdornment position="start">
                        <IoIosCalendar />
                      </InputAdornment>
                    ),
                    value: formik.values.tombola_ended_at,
                    error:
                      Boolean(formik.touched.tombola_ended_at) &&
                      Boolean(formik.errors.tombola_ended_at),
                    helperText:
                      formik.touched.tombola_ended_at &&
                      formik.errors.tombola_ended_at,
                  }}
                  pickerProps={{
                    format: "YYYY-MM-DD HH:mm:ss",
                    disabled: false,
                    showToday: false,
                    showTime: true,
                  }}
                />
              </Grid>
              <br />
              <Grid item xs={12} sm={6} lg={6}>
                <InputField
                  value={formik.values.package_validity_limit}
                  type="number"
                  fullWidth
                  placeholder={formatMessage({
                    id: "sharedScreen.packageValidityLimit",
                  })}
                  label={formatMessage({
                    id: "sharedScreen.packageValidityLimit",
                  })}
                  name="package_validity_limit"
                  //onChange={formik.handleChange}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.package_validity_limit &&
                    Boolean(formik.errors.package_validity_limit)
                  }
                  helperText={
                    formik.touched.package_validity_limit &&
                    formik.errors.package_validity_limit
                  }
                />
              </Grid>
              <br />
              <Grid item xs={12} sm={6} lg={6}>
                <TextField
                  select
                  variant="outlined"
                  size="small"
                  //value={formik.values.partner_business_id}
                  value={selectedBusinessId}
                  label={formatMessage({ id: "sharedScreen.partnerBusiness" })}
                  fullWidth
                  name="partner_business_id"
                  //onChange={formik.handleChange}
                  onChange={(event) => handleBusinessChange(event.target.value)}
                  error={
                    formik.touched.partner_business_id &&
                    Boolean(formik.errors.partner_business_id)
                  }
                  helperText={
                    formik.touched.partner_business_id &&
                    formik.errors.partner_business_id
                  }
                >
                  {businesses.map((business, index) => {
                    return (
                      <MenuItem value={business.id}>
                        {business.company_name}
                      </MenuItem>
                    );
                  })}
                </TextField>
              </Grid>
              <br />
              <Grid item xs={12} sm={6} lg={6}>
                <TextField
                  select
                  variant="outlined"
                  size="small"
                  value={formik.values.business_branch_id}
                  label={formatMessage({ id: "sharedScreen.businessBranch" })}
                  fullWidth
                  name="business_branch_id"
                  onChange={formik.handleChange}
                  error={
                    formik.touched.business_branch_id &&
                    Boolean(formik.errors.business_branch_id)
                  }
                  helperText={
                    formik.touched.business_branch_id &&
                    formik.errors.business_branch_id
                  }
                >
                  {branches.map((branch) => {
                    return <MenuItem value={branch.id}>{branch.name}</MenuItem>;
                  })}
                </TextField>
              </Grid>
              <br />
              <br />
              <Grid item xs={2} sm={2} lg={2}>
                <InputButton
                  disabled={formik.isSubmitting}
                  fullWidth
                  type="submit"
                  variant="contained"
                  color="secondary"
                >
                  <FormattedMessage id="sharedScreen.save" />
                  {formik.isSubmitting && <CircularProgress size={30} />}
                </InputButton>
              </Grid>
              {succeed && (
                <Grid item xs={12} sm={12} lg={12}>
                  <Alert severity="success">
                    <FormattedMessage id="sharedScreen.settingsSavedSuccessfully" />
                  </Alert>
                </Grid>
              )}
            </Box>
          </Grid>

          <Grid item xs={6} sm={6} lg={6}>
            <Box mb={12} component="div" className="settingWrapperInner">
              <Grid item xs={12} sm={6} lg={6}>
                <TextField
                  select
                  variant="outlined"
                  size="small"
                  value={formik.values.first_user}
                  label={formatMessage({ id: "sharedScreen.firstUser" })}
                  fullWidth
                  name="first_user"
                  onChange={formik.handleChange}
                  error={
                    formik.touched.first_user &&
                    Boolean(formik.errors.first_user)
                  }
                  helperText={
                    formik.touched.first_user && formik.errors.first_user
                  }
                >
                  {adminUsers.map((admin, index) => {
                    return (
                      <MenuItem value={admin["id"]}>
                        {admin["user_detail"]["last_name"]}
                      </MenuItem>
                    );
                  })}
                </TextField>
              </Grid>
              <br />

              <Grid item xs={12} sm={6} lg={6}>
                <TextField
                  select
                  variant="outlined"
                  size="small"
                  value={formik.values.second_user}
                  label={formatMessage({ id: "sharedScreen.secondUser" })}
                  fullWidth
                  name="second_user"
                  onChange={formik.handleChange}
                  error={
                    formik.touched.second_user &&
                    Boolean(formik.errors.second_user)
                  }
                  helperText={
                    formik.touched.second_user && formik.errors.second_user
                  }
                >
                  {adminUsers.map((admin, index) => {
                    return (
                      <MenuItem value={admin["id"]}>
                        {admin["user_detail"]["last_name"]}
                      </MenuItem>
                    );
                  })}
                </TextField>
              </Grid>
              <br />

              <Grid item xs={12} sm={6} lg={6}>
                <TextField
                  select
                  variant="outlined"
                  size="small"
                  value={formik.values.third_user}
                  label={formatMessage({ id: "sharedScreen.thirdUser" })}
                  fullWidth
                  name="third_user"
                  onChange={formik.handleChange}
                  error={
                    formik.touched.third_user &&
                    Boolean(formik.errors.third_user)
                  }
                  helperText={
                    formik.touched.third_user && formik.errors.third_user
                  }
                >
                  {adminUsers.map((admin, index) => {
                    return (
                      <MenuItem value={admin["id"]}>
                        {admin["user_detail"]["last_name"]}
                      </MenuItem>
                    );
                  })}
                </TextField>
              </Grid>
              <br />
            </Box>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};
